<template>
  <div>
    <div v-if="tabnumbs > 2" v-animate="'fade-bottom'" class="selectdiv relative lg:hidden bg-transparent mb-8 w-full border border-primary py-1 px-2">
      <select name="LeaveType" onchange="onChange(this.value)" class="lg:hidden text-primary uppercase w-full font-bold text-18" v-model.number="selected">
        <slot name="buttons" />
      </select>
    </div>
    <div v-animate="'fade-bottom'" class="hidden lg:flex gap-x-8 mb-12">
      <button v-if="tabnumbs > 1" class="ui-tabs-tab" :class="{'ui-state-active': selected === 1}" @click="selecttab(1)"><slot name="buttonone" /></button>
      <button v-if="tabnumbs > 1"class="ui-tabs-tab" :class="{'ui-state-active': selected === 2}" @click="selecttab(2)"><slot name="buttontwo" /></button>
      <button v-if="tabnumbs > 2"class="ui-tabs-tab" :class="{'ui-state-active': selected === 3}" @click="selecttab(3)"><slot name="buttonthree" /></button>
      <button v-if="tabnumbs > 3"class="ui-tabs-tab" :class="{'ui-state-active': selected === 4}" @click="selecttab(4)"><slot name="buttonfour" /></button>
      <button v-if="tabnumbs > 4" class="ui-tabs-tab" :class="{'ui-state-active': selected === 5}" @click="selecttab(5)"><slot name="buttonfive" /></button>
      <button v-if="tabnumbs > 5" class="ui-tabs-tab" :class="{'ui-state-active': selected === 6}" @click="selecttab(6)"><slot name="buttonsix" /></button>
    </div>
    <div v-if="selected===1">
      <slot name="sectionone" />
    </div>
    <div v-if="selected===2">
      <slot name="sectiontwo" />
    </div>
    <div v-if="selected===3">
      <slot name="sectionthree" />
    </div>
    <div v-if="selected===4">
      <slot name="sectionfour" />
    </div>
    <div v-if="selected===5">
      <slot name="sectiontfive" />
    </div>
    <div v-if="selected===6">
      <slot name="sectionsix" />
    </div>
  </div>
</template>
<script>
export default {
  props:{
    tabnumbs: Number,
  },
data () {
  return {
    selected: 1,
  }
},
methods: {
  selecttab(tab){
    this.selected = tab
  },
}
}
</script>
